import React, { useMemo, useSyncExternalStore } from 'react';
import { View, ScrollView, Text } from 'react-native';
import { getStyles } from './UpgradeModal.styles';
import ProductCard from './ProductCard';
import { useTheme } from '../../../hooks/useTheme';
import { upsellComboStore } from '../../../store/upsellCombo';
import { useTranslation } from '@oolio-group/localization';

const UpgradeModal = () => {
  const { colors } = useTheme();
  const styles = useMemo(() => getStyles(colors), [colors]);
  const { translate } = useTranslation();

  const { upsellCombos: products } = useSyncExternalStore(
    upsellComboStore.subscribe,
    upsellComboStore.getSnapshot,
  );

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{translate('modal.wouldYouUpgradeItem')}</Text>
      <ScrollView
        horizontal
        style={styles.list}
        contentContainerStyle={styles.listContent}
      >
        {products.map(product => (
          <ProductCard product={product} key={product.id} />
        ))}
      </ScrollView>
    </View>
  );
};

export default UpgradeModal;
